import { createContext, useState, useEffect } from "react";
import Loading from "../components/Loading";
import api from "../services/api";
import useAutoLogout from "../utils/useLogout";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
export const AuthContext = createContext();



export default function AuthProvider({ children }) {
  const [authenticated, setAuthenticated] = useState(false);
  const [loading, setLoading] = useState(false);
  const timer = useAutoLogout(30);

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (token) {
      api.defaults.headers.Authorization = `${token}`;
      setAuthenticated(true);
    }
    setLoading(false);
  }, []);

  async function handleLogin(email, password) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await api.post(
        "/api/users/login",
        { email, password },
        config
      );
      localStorage.setItem("userInfo", JSON.stringify(data));
      localStorage.setItem("token", JSON.stringify(data.token));

      api.defaults.headers.Authorization = data.token;
      setAuthenticated(true);

      const logado = JSON.parse(localStorage.getItem("userInfo"));
      if (logado.emailConfirmado) {
        document.location.href = "/";
      } else {
        setAuthenticated(false);
        localStorage.removeItem("userInfo");
        localStorage.removeItem("token");
        localStorage.removeItem("cart");
        api.defaults.headers.Authorization = undefined;
        document.location.href = "/confirmed";
      }
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      toast.error(err);
    }
  }


  async function handleAdminLogin(email, password) {
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };

      const { data } = await api.post(
        "/api/usersCRC/login",
        { email, password },
        config
      );
      localStorage.setItem("userInfoAdmin", JSON.stringify(data));
      localStorage.setItem("token", JSON.stringify(data.token));

      api.defaults.headers.Authorization = data.token;
      setAuthenticated(true);

      const logado = JSON.parse(localStorage.getItem("userInfoAdmin"));
      if (logado) {
        document.location.href = "/painel";
      } else {
        setAuthenticated(false);
        localStorage.removeItem("userInfoAdmin");
        localStorage.removeItem("token");
        api.defaults.headers.Authorization = undefined;
        document.location.href = "/adminlogin";
      }
    } catch (error) {
      const err =
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message;
      toast.error(err);
    }
  }


  if (loading) {
    return <Loading />;
  }

  function handleLogout(e) {
       
    setAuthenticated(false);
    localStorage.removeItem("userInfo");
    localStorage.removeItem("token");
    localStorage.removeItem("cart");
    api.defaults.headers.Authorization = undefined;
    document.location.href = "/login";
  }



  function handleAdminLogout(e) {
    e.preventDefault();
    setAuthenticated(false);
    localStorage.removeItem("userInfoAdmin");
    localStorage.removeItem("token");
    api.defaults.headers.Authorization = undefined;
    document.location.href = "/adminlogin";
  }

  return (
    <AuthContext.Provider
      value={{
        loading,
        authenticated,
        handleLogin,
        handleLogout,
        handleAdminLogin,
        handleAdminLogout,
        timer,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
}
